import { render } from "./FlexibleSwiper.vue?vue&type=template&id=2ce5dbaa&scoped=true"
import script from "./FlexibleSwiper.vue?vue&type=script&lang=js"
export * from "./FlexibleSwiper.vue?vue&type=script&lang=js"

import "./FlexibleSwiper.vue?vue&type=style&index=0&id=2ce5dbaa&lang=stylus&scoped=true"
import "./FlexibleSwiper.vue?vue&type=style&index=1&lang=stylus"
script.render = render
script.__scopeId = "data-v-2ce5dbaa"

export default script